import $ from "jquery";
import moment from "moment";
import { useEffect, useState } from "react";
import { BiCreditCard, BiInfoCircle } from "react-icons/bi";
import { Link, useLocation, useParams } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import Header from "../../components/partials/Header";
import Sidebar from "../../components/partials/Sidebar";
import PayDtlCard from "../../components/PayDtlCard";
import TruncatedTextWithTooltip from "../../components/TruncatedTextWithTooltip";
import config from "../../config";
import { millionComma, removeMillionComma } from "../../utils";
import {
  formatItemStatusPurchase,
  uomConversion,
  uomConversionUnit,
} from "../Sale/util";
import "./style.css";
import { formatAmount, formatStatus } from "./util";
import ItemViews from "../Master/Item/view";
import { Modal } from "react-bootstrap";
import Tippy from "@tippyjs/react";
import { ConfigContext } from "../../App";
import { useContext } from "react";

function PurchaseView(props) {
  const isPurchaseVoucherNo = useContext(ConfigContext)?.isPurchaseVoucherNo;
  const itemLevelNarration = useContext(ConfigContext)?.itemLevelNarration;
  const { id } = useParams();
  const location = useLocation();
  let filter = location.state?.currentFilter;
  let currentFilterState = location.state?.showFilter;
  let page = location.state?.currentPageNo;

  const itemDtl = {
    item_id: "",
    item_name: "",
    po_qty: "",
    rate: "",
    amount: "",
    godown_id: "",
    alt_conv: "",
    base_uom: "",
    alt_uom: "",
    uom: "",
    alt_qty: "",
    alt_price: "",
    alt_rate: "",
    base_rate: "",
    narration: "",
  };
  const payDtl = [
    { mode: "Cash UGX", conv: 1, conv_amt: "", amt: "" },
    { mode: "USD", conv: 1, conv_amt: "", amt: "" },
    { mode: "Momo Pay", conv: 1, conv_amt: "", amt: "" },
    { mode: "Airtel Money", conv: 1, conv_amt: "", amt: "" },
  ];

  const initialState = {
    po_no: "",
    po_id: "",
    branch_id: "",
    buyer_id: "",
    inv_no: "",
    po_date: moment().format("YYYY-MM-DD"),
    item_dtl: [itemDtl],
    pay_dtl: payDtl,
    vehicle_no: "",
    narration: "",
    payment_mode_id: 1,
    voucher_id: "",
  };

  const [formInputs, setFormInputs] = useState(initialState);
  const [showItemModal, setShowItemModal] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const handleItemView = (data) => {
    setSelectedItemId(data);
    setShowItemModal(true);
  };
  const handleItemModalClose = () => {
    setShowItemModal(false);
    setSelectedItemId(null);
  };

  console.log("formInputsformInputs", formInputs);

  const [purchase, setPurchase] = useState(location.state?.purchase || []);

  console.log("purchasepurchasepurchase", purchase);

  const [user, setUser] = useState({});
  const [voucherList, setVoucherList] = useState([]);
  const multiPurchaseVoucher = useContext(ConfigContext)?.multiPurchaseVoucher;

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  const [godown, setGodown] = useState([]);
  useEffect(
    function () {
      setGodown(() => props.godown);
    },
    [props],
  );

  useEffect(
    function () {
      if (purchase.length == 0) {
        $.post(
          `${config.apiUrl}/purchaseOrder/listPurchaseOrder`,
          JSON.stringify({ po_id: id }),
          function (res) {
            setPurchase(res?.data?.list?.[0] || []);
          },
        );
      }
    },
    [purchase],
  );

  useEffect(
    function () {
      if (multiPurchaseVoucher == 1) {
        $.post(
          `${config.apiUrl}/voucher/listVoucher`,
          JSON.stringify({
            paginate: 0,
            is_active: 1,
            module_name: "purchase",
          }),
          function (res) {
            setVoucherList(res?.data?.list || []);
          },
        );
      }
    },
    [multiPurchaseVoucher],
  );

  useEffect(function () {
    let itemDtl = [];
    purchase?.item_dtl?.forEach((item) => {
      itemDtl.push({
        item_id: item?.item_id,
        item_name: item?.mst_item?.item_name,
        narration: item?.narration || "",
        po_qty: item?.po_qty,
        rate: item?.rate,
        amount: item?.amount,
        godown_id: item?.godown_id,
        alt_conv: item?.alt_conv,
        base_uom: item?.base_uom,
        alt_uom: item?.alt_uom,
        uom: item?.uom,
        // alt_qty: item?.alt_qty,
        alt_qty: item?.alt_qty,
        alt_price: item?.alt_price,
        alt_rate: item?.alt_rate,
        base_rate: item?.base_rate,
      });
    });
    setFormInputs((prevState) => {
      return {
        po_id: purchase?.po_id,
        po_no: purchase?.po_no,
        po_date: purchase?.po_date
          ? moment(purchase?.po_date).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
        branch_id: purchase?.branch_id,
        buyer_id: purchase?.buyer_id,
        inv_no: purchase?.inv_no,
        vehicle_no: purchase?.vehicle_no,
        narration: purchase?.narration,
        payment_mode_id: purchase?.payment_mode_id,
        item_dtl: itemDtl,
        pay_dtl: purchase?.pay_dtl
          ? JSON.parse(purchase.pay_dtl)
          : prevState.pay_dtl,
        voucher_id: purchase?.voucher_id || "",
      };
    });
  }, []);

  useEffect(() => {
    if (purchase && Array.isArray(purchase.item_dtl)) {
      let prod = [...purchase?.item_dtl];

      for (let i = 0; i < prod?.length; i++) {
        let element = {};
        element = prod[i];
        if (element.uom == element.alt_uom) {
          let newProdDtl = {
            ...element,
            po_qty: element.alt_qty,
            alt_qty: element.po_qty,
          };
          prod[i] = newProdDtl;
        }
      }

      setFormInputs((prevState) => {
        let newState = {
          ...prevState,
          item_dtl: prod,
          pay_dtl: purchase?.pay_dtl
            ? JSON.parse(purchase.pay_dtl)
            : prevState.pay_dtl,
        };

        return newState;
      });
    }
  }, [purchase]);

  const [showPayDtl, setShowPayDtl] = useState(false);
  const handlePayDtl = () => {
    setShowPayDtl((prevState) => !prevState);
  };

  let totalAtm = formatAmount(formInputs);
  console.log("totalAtmtotalAtmtotalAtm", totalAtm);
  function getPaymentMode() {
    const paymentModes = formInputs.pay_dtl.filter(
      (pay) => pay.amt !== "" && pay.amt !== undefined && pay.amt > 0,
    );

    if (paymentModes.length === 0) {
      return "Cash UGX";
    } else if (paymentModes.length === 1) {
      return paymentModes[0].mode;
    } else {
      return "Multiple";
    }
  }
  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div
          className="content m-1 p-2 position-relative"
          style={{ paddingBottom: "8rem" }}
        >
          <Header />
          <Breadcrumb path={["Purchase", "View Purchase"]} />

          <main className="bg-white rounded-2" id="purchaseAdd">
            <div className="container-fluid p-2 position-relative">
              <Link
                to="/purchase"
                className="position-absolute text-decoration-none small"
                style={{ top: "-1.5rem", right: "0" }}
                state={{
                  backToCurrent: page,
                  appliedFilter: filter,
                  filterDisplay: currentFilterState,
                  pageSize: location.state?.pageSize || 10,
                }}
              >
                Go Back to List
              </Link>
              <form autoComplete="off">
                <div className="row mb-1">
                  <div className="col-md-3">
                    <label htmlFor="po_no">Purchase No</label>
                    <input
                      type="text"
                      className="form-control"
                      id="po_no"
                      value={purchase?.po_no || ""}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="buyer_id">Supplier Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="buyer_id"
                      value={purchase?.mst_buyer?.buyer_name || ""}
                      disabled
                    />
                  </div>
                  {multiPurchaseVoucher == 1 ? (
                    <div className="col-md-3">
                      <label htmlFor="voucher_id">Voucher Type</label>
                      <select
                        className="form-select"
                        value={formInputs.voucher_id}
                        name="voucher_id"
                        disabled
                      >
                        <option value="" hidden>
                          Select...
                        </option>
                        {voucherList &&
                          voucherList?.map((list) => (
                            <option key={list.voucher_id} value={list.voucher_id}>
                              {`${list.voucher_name}${
                                list.voucher_series || list.current_value
                                  ? ` (${list.voucher_series || ""}${list.current_value ?? ""})`
                                  : ""
                              }${
                                list.purchase_ledger || list.sales_ledger
                                  ? ` - ${list.purchase_ledger || list.sales_ledger}`
                                  : ""
                              }`}
                            </option>
                          ))}
                      </select>
                    </div>
                  ) : null}
                  <div className="col-md-3">
                    <label htmlFor="inv_no">Invoice No</label>
                    <input
                      type="text"
                      className="form-control"
                      id="inv_no"
                      value={purchase.inv_no}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="purchase_type">Purchase Type</label>
                    <input
                      type="text"
                      className="form-control"
                      style={{ textTransform: "capitalize" }}
                      id="purchase_type"
                      value={purchase?.purchase_type || ""}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="invoice_date">Invoice Date</label>
                    <input
                      type="text"
                      className="form-control"
                      id="invoice_date"
                      value={
                        purchase?.invoice_date
                          ? moment(purchase.invoice_date).format("DD-MM-YYYY")
                          : ""
                      }
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="voucher_no">Voucher No</label>
                    <input
                      type="text"
                      className="form-control"
                      id="voucher_no"
                      value={purchase?.voucher_no || ""}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="vehicle_no">Vehicle No</label>
                    <input
                      type="text"
                      className="form-control"
                      id="vehicle_no"
                      value={purchase.vehicle_no}
                      disabled
                    />
                  </div>

                  <div className="col-md-3">
                    <label htmlFor="created_by_name">Created By</label>
                    <input
                      type="text"
                      className="form-control"
                      id="created_by_name"
                      value={purchase?.created_by_name || ""}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="created_on">Created On</label>
                    <input
                      type="text"
                      className="form-control"
                      id="created_on"
                      value={
                        purchase?.created_on
                          ? moment(purchase.created_on).format(
                              "DD-MM-YYYY hh:mm A",
                            )
                          : ""
                      }
                      disabled
                    />
                  </div>

                  <div className="col-md-3">
                    <label htmlFor="narration">Narration</label>
                    <textarea
                      type="text"
                      className="form-control"
                      id="narration"
                      value={purchase?.narration}
                      disabled
                    />
                  </div>

                  <div className="col-md-3">
                    <label htmlFor="po_date">Purchase Date</label>
                    <input
                      type="text"
                      className="form-control"
                      id="po_date"
                      value={moment(purchase.po_date).format("DD-MM-YYYY")}
                      disabled
                    />
                  </div>
                  {user.role_id != 3 && user.role_id != 4 && (
                    <div className="col-md-3">
                      <label htmlFor="branch_name">Branch Name</label>

                      <input
                        type="text"
                        className="form-control"
                        id="branch_name"
                        // value={purchase?.mst_branch?.branch_name}
                        value={
                          props?.branchList?.find(
                            (x) => x?.value === purchase?.branch_id,
                          )?.label
                        }
                        disabled
                      />
                    </div>
                  )}
                  <div className="col-md-3">
                    <label htmlFor="is_active">Status</label>
                    <input
                      type="text"
                      className="form-control"
                      id="is_active"
                      value={formatStatus(purchase)}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="payment_mode_id">Payment Mode</label>
                    <input
                      type="text"
                      className="form-control"
                      id="payment_mode_id"
                      value={
                        config?.paymentMode?.find(
                          (p) => p?.value == purchase?.payment_mode_id,
                        )?.label || "N/A"
                      }
                      disabled
                    />
                  </div>
                  {purchase.payment_mode_id == "2" && (
                    <div className="col-md-3">
                      <label htmlFor="is_zero_value">Zero Valued</label>
                      <select
                        name="is_zero_value"
                        value={purchase.is_zero_value ?? ""}
                        className="form-select"
                        disabled
                      >
                        <option value="">NA</option>
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </select>
                    </div>
                  )}
                </div>
                <div className="row">
                  <div className="col-12 p-1">
                    <table
                      className="table mt-4 rounded"
                      cellPadding="0"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th>Item Name</th>
                          <th>Godown</th>
                          <th>UOM</th>
                          <th>Qty</th>
                          <th>Rate</th>
                          <th>Amount</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formInputs.item_dtl &&
                          formInputs.item_dtl.map((v, i) => (
                            <tr key={i}>
                              <td style={{ width: "400px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "1px",
                                  }}
                                >
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={v?.mst_item?.item_name}
                                    disabled
                                  />
                                  <Tippy content="View Item">
                                    <div>
                                      {" "}
                                      <span
                                        className=""
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleItemView(v)}
                                      >
                                        <BiInfoCircle size={20} />
                                      </span>
                                    </div>
                                  </Tippy>
                                </div>
                                {itemLevelNarration == 1 ? (
                                  <textarea
                                    type="text"
                                    className="form-control mt-1"
                                    name={"narration"}
                                    value={v?.narration}
                                    disabled
                                    maxLength={100}
                                  />
                                ) : null}
                              </td>
                              <td style={{ width: "170px" }}>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={
                                    godown?.find(
                                      (x) => x?.godown_id === v?.godown_id,
                                    )?.godown_name || "-"
                                  }
                                  disabled
                                />
                              </td>
                              <td style={{ width: "100px" }}>
                                {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <select
                                    id=""
                                    name="uom"
                                    value={v?.uom}
                                    disabled
                                    className="form-select"
                                  >
                                    {[v.base_uom, v.alt_uom].map((ele, ind) => (
                                      <option value={ele}>{ele}</option>
                                    ))}
                                  </select>
                                )}
                              </td>
                              <td style={{ width: "100px" }}>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  value={parseFloat(v?.po_qty || 0).toFixed(2)}
                                  disabled
                                />
                                {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <span
                                    className="text-right"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    {/* {uomConversionUnit(v)} */}
                                    <TruncatedTextWithTooltip
                                      text={uomConversionUnit(v)}
                                    />
                                  </span>
                                )}
                              </td>
                              <td style={{ width: "130px", maxWidth: "130px" }}>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  // value={millionComma(v?.rate)}
                                  value={
                                    v?.uom == v?.alt_uom
                                      ? millionComma(v?.alt_price)
                                      : millionComma(v?.rate)
                                  }
                                  disabled
                                />
                                {v?.alt_uom != null &&
                                  v?.alt_uom !== "" &&
                                  (v?.uom == v?.alt_uom ? (
                                    <span
                                      style={{
                                        wordBreak: "break-all",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {`( ${v?.rate} Per `}
                                      <TruncatedTextWithTooltip
                                        text={uomConversion(v)}
                                      />
                                      {`)`}
                                    </span>
                                  ) : (
                                    <span
                                      style={{
                                        wordBreak: "break-all",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {`(${v?.alt_price} Per `}
                                      <TruncatedTextWithTooltip
                                        text={uomConversion(v)}
                                      />
                                      {`)`}
                                    </span>
                                  ))}
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  value={millionComma(v?.amount)}
                                  disabled
                                />
                              </td>

                              <td style={{ width: "100px" }}>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={formatItemStatusPurchase(v)}
                                  disabled
                                />
                              </td>
                              {/* <td>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="status"
                                                    value={formatStatus(v, 'status')}
                                                    disabled
                                                />
                                            </td> */}
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </form>
            </div>
            <div className="container-fluid mt-5">
              <div className="row">
                <div className="col-12 position-absolute bottom-0 start-0 end-0">
                  <div
                    className="row rounded px-2 py-3"
                    style={{ background: "#F4F7FE" }}
                  >
                    <div className="col-md-3">
                      <label htmlFor="round_off">Round off</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        id="round_off"
                        value={purchase?.round_off || 0}
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor="total">Gross Total</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        id="total"
                        value={formatAmount(formInputs)}
                        disabled
                      />
                    </div>
                    <div className="col d-flex mt-auto justify-content-end gap-2">
                      <div
                        style={{
                          border: "1px solid gray",
                          height: "37px",
                          minWidth: "200px",
                          borderRadius: "5px",
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <b className="me-2">{getPaymentMode()} </b> :{" "}
                        <span className="ms-2">
                          {" "}
                          {formatAmount(formInputs)}
                        </span>
                      </div>
                      <BiCreditCard
                        size={32}
                        className="text-primary mt-1"
                        role="button"
                        onClick={handlePayDtl}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      {showPayDtl && (
        <PayDtlCard
          cardMode="view"
          showPayDtl={showPayDtl}
          handlePayDtl={handlePayDtl}
          formInputs={formInputs}
          setFormInputs={setFormInputs}
          grossTotal={removeMillionComma(totalAtm)}
          // grossInputs={totalAtm}
        />
      )}
      <Modal
        show={showItemModal}
        onHide={handleItemModalClose}
        keyboard={false}
        backdrop="static"
        size="lg"
      >
        <ItemViews id={selectedItemId} hide={handleItemModalClose} />
      </Modal>
    </>
  );
}

export default PurchaseView;
